<template>
  <div>
    <v-divider class="mt-4"></v-divider>
    <v-row no-gutters class="mt-4">
      <v-col lg="2" md="4" sm="6" xs="12">
        <div class="text-subtitle-2">Room Name:</div>
      </v-col>
      <v-col lg="4" md="4" sm="6" xs="12">{{ Room.beRoomType.name }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col lg="2" md="4" sm="6" xs="12">
        <div class="text-subtitle-2">Rate Name:</div>
      </v-col>
      <v-col lg="4" md="4" sm="6" xs="12">{{ Room.beRoomTypeRatePlan.name }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col lg="2" md="4" sm="6" xs="12">
        <div class="text-subtitle-2">Occupancy:</div>
      </v-col>
      <v-col lg="4" md="4" sm="6" xs="12">{{Room.adult}} adults and {{Room.child}} children</v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12">
        <div class="text-subtitle-2 font-weight-black">
          Rate Breakdown for {{ Room.beRoomCharges.length }} night(s)
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mx-0" v-for="(price, iprice) in Room.beRoomCharges" :key="iprice + 'room-charges'">
      <v-col lg="4" md="4" sm="4" xs="6">
        <div class="text-subtitle-2">{{ formatDate(price.chargeRoomDate) }}</div>
      </v-col>
      <v-col lg="4" md="4" sm="4" xs="6">
        <div class="text-subtitle-2">Amount: {{ price.displayAmount }}</div>
        <div v-if="price.extraPersonCharge > 0" class="text-subtitle-2">Extra Person: {{ price.displayExtraPersonCharge }}</div>
      </v-col>
    </v-row>

    <v-row class="mt-4" v-if="Room.beRoomChargeExtras.length !== 0">
      <v-col cols="12">
        <div class="text-subtitle-2 font-weight-black">
          Add On
        </div>
      </v-col>
    </v-row>

    <v-row v-if="Room.beRoomChargeExtras.length !== 0" 
    no-gutters class="mx-0" v-for="(extra, iprice) in Room.beRoomChargeExtras"
     :key="iprice + 'room-extra'">
      <v-col lg="4" md="4" sm="4" xs="6">
        <div class="text-subtitle-2 my-1" style="line-height: 1">{{ extra.extraServiceName }}-{{ extra.description }}</div>
      </v-col>
      <v-col lg="4" md="4" sm="4" xs="6">
        <div class="text-subtitle-2">Amount: {{ extra.displayAmount }}</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    Room: {
      type: Object,
      require: true,
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("dddd Do MMMM YYYY");
    },
  },
};
</script>